<template>
  <!--  <div v-if="user_accesses && userService.hasAccess(user_accesses, ['admin'])"-->
  <div v-if="(user_accesses && userService.hasAccess(user_accesses, ['admin']))" class="p-grid crud-demo">
    <div class="p-col-12">
      <div class="card">
        <Toast/>
        <Toolbar class="p-mb-4 table-toolbar">
          <template slot="left">
            <Button label="New" icon="pi pi-plus" class="p-button-success p-mr-2" @click="newRole"/>
            <Button label="Delete" icon="pi pi-trash" class="p-button-danger" @click="confirmDeleteSelected"
                    :disabled="!selectedRoles || !selectedRoles.length"/>
          </template>

          <template slot="right">
            <Button label="Access" icon="pi pi-plus" class="p-button-success p-mr-2" @click="addAccessModal = true"/>
            <Button label="Export" icon="pi pi-upload" class="p-button-info" @click="exportCSV($event)"/>
          </template>
        </Toolbar>

        <DataTable ref="dt" :value="roles" :selection.sync="selectedRoles" dataKey="id" :paginator="true"
                   :rows="10" :filters="filters"
                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                   :rowsPerPageOptions="[5,10,25]"
                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} roles">
          <template #header>
            <div class="table-header">
              <h5 class="p-m-0">Manage Roles</h5>
              <span class="p-input-icon-left">
                <i class="pi pi-search"/>
                <InputText v-model="filters['global']" placeholder="Search..."/>
              </span>
            </div>
          </template>

          <Column selectionMode="multiple" headerStyle="width: 4rem"></Column>
          <Column field="name" header="Name" sortable>
            <template #body="slotProps">
              <span>{{slotProps.data.name}}</span>
            </template>
          </Column>
          <Column field="accesses" header="Accesses" sortable>
            <template #body="slotProps">
              <span>{{displayAccesses(slotProps.data.accesses)}}</span>
            </template>
          </Column>
          <Column>
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                      @click="editRole(slotProps.data)"/>
              <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
                      @click="confirmDeleteRole(slotProps.data)"/>
            </template>
          </Column>
        </DataTable>

        <div v-if="roles == null" class="loader">
          <scale-out class="loader-style"></scale-out>
        </div>

        <Dialog :visible.sync="deleteRoleDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
          <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
            <span v-if="role">Are you sure you want to delete <b>{{role.name}}</b>?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteRoleDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteRole"/>
          </template>
        </Dialog>

        <Dialog class="role-dialog"
                :header="mode === 'edit' ? 'Update Role' : 'Add Role'"
                :visible.sync="addRoleModal"
                :style="{width: '30vw'}"
                :modal="true">
          <div class="p-col-12">
            <span class="p-field">
              <label style="display: block;" for="role_name">Role name</label>
              <InputText class="p-col-12 card-input" id="role_name" type="text" v-model="role_name"/>
            </span>
          </div>
          <div class="p-col-12">
            <span class="p-field">
              <MultiSelect class="role-multiselect" id="roles" v-model="accesses" :options="access_list"
                           optionLabel="name" placeholder="Select Access"/>
            </span>
          </div>
          <div style="padding-top: 175px"></div>
          <template #footer>
            <Button label="Cancel" icon="pi pi-times" @click="addRoleModal = false" class="p-button-text"/>
            <Button label="Submit" icon="pi pi-check" @click="mode === 'edit' ? updateRole() : addRole()" autofocus/>
          </template>
        </Dialog>

        <Dialog class="role-dialog" header="Add Access" :visible.sync="addAccessModal" :style="{width: '30vw'}"
                :modal="true">
              <span class="p-field">
                <label style="display: block;" for="role_name">Name</label>
                <InputText class="p-col-12 card-input" id="access_name" type="text" v-model="access_name"/>
              </span>
          <template #footer>
            <Button label="Cancel" icon="pi pi-times" @click="addAccessModal = false" class="p-button-text"/>
            <Button label="Submit" icon="pi pi-check" @click="addAccess" autofocus/>
          </template>
        </Dialog>

        <Dialog :visible.sync="deleteRolesDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
          <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
            <span v-if="role">Are you sure you want to delete the selected roles?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteRolesDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedRoles"/>
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
  import RoleService from '../../services/RoleService';
  import UserService from '../../services/UserService';
  import {ScaleOut} from 'vue-loading-spinner';

  export default {
    components: { ScaleOut },
    data() {
      return {
        roles: null,
        mode: 'add',
        addRoleModal: false,
        deleteRoleDialog: false,
        deleteRolesDialog: false,
        addAccessModal: false,
        role: {},
        selectedRoles: null,
        access_name: '',
        role_name: '',
        access_list: [],
        accesses: null,
        filters: {},
        submitted: false,
        displayGallery: false,
        images: [],
        responsiveOptions: [
          {
            breakpoint: '1024px',
            numVisible: 5
          },
          {
            breakpoint: '768px',
            numVisible: 3
          },
          {
            breakpoint: '560px',
            numVisible: 1
          }
        ],
        user_accesses: this.$store.state.accesses,
        userService: null,
        roleService: null,
      }
    },
    created() {
      this.roleService = new RoleService();
      this.userService = new UserService();
      if (!this.user_accesses){
        let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
        this.userService.getUserAccesses(user_info.id).then(result => {
          if (result.status === 200) {
            let accesses = result.data.accesses;
            this.$store.state.accesses = accesses;
            this.user_accesses = accesses;
          }
        });
      }
    },
    mounted() {
      this.roleService.listRoles().then(response => this.roles = response.data.roles);
      this.roleService.listAccesses().then(response => this.access_list = response.data.accesses);
    },
    methods: {
      formatCurrency(value) {
        return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
      },
      addAccess() {
        this.roleService.setAccess(this.access_name).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Access Added',
              life: 3000
            });
            this.roleService.listAccesses().then(response => this.access_list = response.data.accesses);
            this.access_name = '';
            this.addAccessModal = false;
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to add access!',
              detail: result.data.error
            });
          }
        });
      },
      newRole() {
        this.mode = 'add';
        this.role_name = '';
        this.accesses = [];
        this.addRoleModal = true
      },
      addRole() {
        this.roleService.setRole(this.role_name, this.accesses.map(access => access.name)).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Role Added',
              life: 3000
            });
            location.reload();
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to add role!',
              detail: result.data.error
            });
          }
        });
      },
      mapAccesses(accesses) {
        accesses = accesses ? accesses : this.role.accesses;
        if (!accesses || accesses.length === 0)
          return [];

        return accesses.map(access => {
          const item = {};
          item.name = access.name;
          // item.name = access.name.replace("_", " ").replace(/\b[a-z]/g, match => match.toUpperCase());
          item.code = access.name;
          return item;
        });
      },
      displayAccesses(accesses) {
        accesses = this.mapAccesses(accesses);
        if (!accesses || accesses.length === 0)
          return "";

        return accesses.map(access => access.name).join(", ");
      },
      editRole(role) {
        this.mode = 'edit';
        this.role = role;
        this.role_name = role.name;
        this.accesses = role.accesses;
        this.addRoleModal = true
      },
      updateRole() {
        this.roleService.updateRole(this.role.id, this.role_name, this.mapAccesses(this.accesses)).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Role Updated',
              life: 3000
            });
            location.reload();
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to update role!',
              detail: result.data.error
            });
          }
        });
      },
      confirmDeleteRole(role) {
        this.role = role;
        this.deleteRoleDialog = true;
      },
      deleteRole() {
        this.roles = this.roles.filter(val => val.id !== this.role.id);
        this.roleService.deleteRoles([this.role.id]).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Role Deleted!',
              life: 3000
            });
            this.deleteRoleDialog = false;
            this.role = {};
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to delete!',
              detail: result.data.error
            });
          }
        });
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.roles.length; i++) {
          if (this.roles[i].id === id) {
            index = i;
            break;
          }
        }

        return index;
      },
      createId() {
        let id = '';
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      exportCSV() {
        this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteRolesDialog = true;
      },
      deleteSelectedRoles() {
        this.roles = this.roles.filter(val => !this.selectedRoles.includes(val));
        this.roleService.deleteRoles(this.selectedRoles.map((obj) => obj.id)).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Selected Roles Deleted!',
              life: 3000
            });
            this.selectedRoles = null;
            this.deleteRolesDialog = false;
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to delete!',
              detail: result.data.error
            });
          }
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .product-image {
    width: 100px;
    border-radius: 2em;

    &:hover {
      cursor: pointer;
    }

    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);*/
  }

  .p-dialog .product-image {
    width: 150px;
    margin: 0 auto 2rem auto;
    display: block;
  }

  .confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;

    &.status-active {
      background: #C8E6C9;
      color: #256029;
    }

    &.status-inactive {
      background: #FFCDD2;
      color: #C63737;
    }
  }

  .role-multiselect {
    width: 100%;
    margin-bottom: 1rem;
  }
</style>
